export const SET_NOTIFICATION = "SET_NOTIFICATION";
export const RESET_NOTIFICATION = "RESET_NOTIFICATION";

export const CHANGE_UNIVERSAL_MODALS = "CHANGE_UNIVERSAL_MODALS";
